import React from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { Theme } from '@orijinworks/frontend-commons';

export function CasePlanDetailsError({ classes, error, onBack }) {
  return (
    <Theme>
      <Box className={classes.page} role="main" aria-label="Case plan details">
        <Box className={classes.errorContainer}>
          <Typography variant="h6" color="error">
            {error}
          </Typography>
          <Button variant="contained" color="primary" onClick={onBack}>
            Back to All Plans
          </Button>
        </Box>
      </Box>
    </Theme>
  );
}
